.elementWrapper {
  margin-bottom: 20px;
  max-width: 800px;
}

.limitMaxWidth {
  max-width: 400px;
}
